import { render, staticRenderFns } from "./general-ledger.vue?vue&type=template&id=b21d4350&scoped=true"
import script from "./general-ledger.vue?vue&type=script&lang=js"
export * from "./general-ledger.vue?vue&type=script&lang=js"
import style0 from "./general-ledger.vue?vue&type=style&index=0&id=b21d4350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21d4350",
  null
  
)

export default component.exports